import React from 'react';
import './LicensePlate.css';
import { TextField } from '@mui/material';

const LicensePlate = ({ value, onChange }) => {
  // Format input to match Dutch license plate format
  const handleChange = (e) => {
    let input = e.target.value.toUpperCase();
    // Remove any non-alphanumeric characters
    input = input.replace(/[^A-Z0-9]/g, '');
    
    // Format the license plate (XX-999-X or 99-XXX-9)
    if (input.length <= 6) {
      let formatted = input;
      onChange(formatted);
    }
  };

  return (
    <div className="license-plate-container">
      <TextField
        value={value}
        onChange={handleChange}
        placeholder="XX-999-X"
        inputProps={{
          maxLength: 8,
          className: "license-plate-input",
        }}
        sx={{
          '& .MuiInputBase-root': {
            backgroundColor: '#F7B731',
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontWeight: 'bold',
            fontSize: '20px',
            width: '140px',
            height: '40px',
          },
          '& .MuiOutlinedInput-input': {
            textAlign: 'center',
            padding: '8px 14px',
            letterSpacing: '2px',
          }
        }}
      />
    </div>
  );
};

export default LicensePlate;